import { Form, Row, theme } from "antd";
import { useCallback, useEffect, useMemo } from "react";
import dayjs from "dayjs";
import FormItem from "../../form/form-item";
import WorktimeTable from "../../fragments/worktime-table";

function SettlementBookings({ filter, setFilter }) {
  const [form] = Form.useForm();

  const [begin, end] = useMemo(() => {
    if(filter.bookingPeriod === 'PREVIOUS_MONTHS') {
      return [dayjs('2000-01-01'), dayjs().startOf('month')];
    }
    if(filter.bookingPeriod === 'MONTH' && filter.month) {
      const monthBegin = dayjs(filter.month).startOf('month');
      return [monthBegin, monthBegin.add(1, 'month')];
    }
    return [undefined, undefined];
  }, [filter.bookingPeriod, filter.month])

  const { token } = theme.useToken();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  const onFieldsChange = useCallback(() => {
    const values = { ...filter, ...form.getFieldsValue() }
    if(JSON.stringify(values) !== JSON.stringify(filter)) {
      setFilter(values)
    }
  }, [form, filter, setFilter])

  useEffect(() => {
    form.setFieldsValue(filter);
  }, [form, filter])

  return (<>
    <Form form={form} style={formStyle} onFieldsChange={onFieldsChange}>
      <Row><h3>Filter</h3></Row>
      <Row gutter={24}>
        <FormItem fieldName="bookingPeriod" label="Zeitraum" type="enum" typeData={{ options: [{ value: 'MONTH', label: "Ausgewählter Monat" }, { value: 'PREVIOUS_MONTHS', label: "Vormonate" }], multiple: false }} />
        { filter.bookingPeriod === 'MONTH' && <FormItem fieldName="month" label="Monat" type="month" /> }
        <FormItem fieldName="withoutClosure" label="Ohne Abrechnung" type="check" />
      </Row>
    </Form>

    <div style={{ marginTop: '2em' }}>
      <WorktimeTable
        preselectedEmployeeClosureId={filter.withoutClosure ? null : undefined}
        begin={begin}
        end={end}
      />
    </div>
  </>)
}

export default SettlementBookings;
